<script>
    import images from './images.js';

    export let args;
    const [sign, icon, count] = args;
</script>

<span style="display: inline-block; white-space: pre">{(sign === '-') ? '−' : '+'} {#each {length: count} as _, i}<svelte:component this={images[icon]}/>{/each}</span>